import { defineMessages } from 'react-intl';

export const voiceFeedbackMessages = defineMessages({
  thumbUpTitle: {
    defaultMessage: 'What did you like?',
    id: '2wodG+ZnuW',
    description: 'Popover title when submitting positive Talk-to-Heidi feedback',
  },
  thumbDownTitle: {
    defaultMessage: 'What went wrong?',
    id: 'y496gWPzYd',
    description: 'Popover title when submitting negative Talk-to-Heidi feedback',
  },
  thumbUpPlaceholder: {
    defaultMessage: 'Tell Heidi what worked well (optional)',
    id: 'xTfXagFuT2',
    description: 'Optional comment placeholder for positive Talk-to-Heidi feedback',
  },
  thumbDownPlaceholder: {
    defaultMessage: 'Tell Heidi how this could be better (optional)',
    id: 'wz2Ai+GE9+',
    description: 'Optional comment placeholder for negative Talk-to-Heidi feedback',
  },
  thanksForFeedback: {
    defaultMessage: 'Thanks for the feedback',
    id: 'Wk3AHWoMu0',
    description: 'Toast after Talk-to-Heidi feedback is submitted successfully',
  },
  couldntSubmitFeedback: {
    defaultMessage: "Couldn't submit feedback",
    id: 'Th4ipKdFpZ',
    description: 'Toast title when Talk-to-Heidi feedback submission fails',
  },
  pleaseTryAgain: {
    defaultMessage: 'Please try again.',
    id: 'peAeDGHNF2',
    description: 'Toast description when Talk-to-Heidi feedback submission fails',
  },
  giveFeedback: {
    defaultMessage: 'Give feedback',
    id: 'MHJitpntPB',
    description: 'Accessible label for the always-available Talk-to-Heidi feedback entry',
  },
  positiveTooltip: {
    defaultMessage: 'Good response',
    id: 'rjsyb4t+7m',
    description: 'Tooltip shown when hovering the positive Talk-to-Heidi feedback button',
  },
  negativeTooltip: {
    defaultMessage: 'Bad response',
    id: 'qdrToYum7s',
    description: 'Tooltip shown when hovering the negative Talk-to-Heidi feedback button',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'YD68mFXOFb',
    description: 'Dismiss the Talk-to-Heidi feedback popover without submitting',
  },
  submit: {
    defaultMessage: 'Submit',
    id: '9/t/poUD61',
    description: 'Send Talk-to-Heidi feedback from the popover',
  },
  submitting: {
    defaultMessage: 'Submitting...',
    id: 'rUx7PWt1cg',
    description: 'Submit button label while Talk-to-Heidi feedback is being sent',
  },
});
